import { useQuery } from 'react-query'
import { AxiosInstance } from 'axios'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

type teamSolutionsParams = {
  teamId?: number
  enabled?: boolean
}

type TeamSolutionType = {
  id: string
  name: string
  sub_name: string
  label: string
}

const fetchTeamSolutions = async (
  apiClient: AxiosInstance,
  params: teamSolutionsParams
): Promise<TeamSolutionType[]> => {
  const { data } = await apiClient.get(
    `/ajax/offices/${params.teamId}/solutions`
  )
  return data.data.solutions
}

export const useGetTeamSolutionTypes = (params: teamSolutionsParams) => {
  const apiClient = useAxiosContext()

  return useQuery<TeamSolutionType[], Error>(
    ['team-solution-types', params],
    () => fetchTeamSolutions(apiClient, params),
    {
      enabled: params.enabled !== false && params.teamId !== undefined,
    }
  )
}
